var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBedroombig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20.344pt",
    height: "20.344pt",
    viewBox: "0 0 20.344 20.344",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.094 20.094v-0.25h-19.594v-19.344h19.344v19.594h0.25v-0.25 0.25h0.25v-20.094h-20.344v20.344h20.344v-0.25",
    fill: "#231f20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedroombig);
export default __webpack_public_path__ + "static/media/bedroombig.5e21c3afdf7ca6166695d0b5ea836284.svg";
export { ForwardRef as ReactComponent };